import { ReactElement, useEffect, useState } from 'react';
import { useFormikContext, Field } from 'formik';
import { FormType } from '@constants';
import { FileUploadGroup, LimitedTextAreaLarge } from '@components';
import { getValidFilesConfig } from '@api';
import { iInfringementExtensionFormValues } from '@services/InfringementExtensionService';

import styles from './InfringementExtStep6.module.scss';

function InfringementExtStep6(): ReactElement {
  const { values }: { values: iInfringementExtensionFormValues } = useFormikContext();
  const context = useFormikContext();

  const [fileDescrption, setFilesDescription] = useState('You may upload a maximum of 5 files; each file should be less than 4MB.');
  const [fileSizeLimit, setFileSizeLimit] = useState('4');
  const [fileNumberLimit, setFileNumberLimit] = useState(5);

  useEffect(() => {
    const getFileInfo = async (): Promise<void> => {
      getValidFilesConfig().then((responseBody) => {
        if (responseBody) {
          const infringementData = responseBody.find((response) => response.FormType === FormType.INFRINGEMENTEXTENSION);
          if (infringementData?.Description) {
            setFilesDescription(infringementData?.Description);
          }
          if (infringementData?.FileSize) {
            setFileSizeLimit(Math.floor(infringementData?.FileSize / 1000000).toString());
            context.setFieldValue('FileSizeLimitSupportingDoc', Math.floor(infringementData?.FileSize / 1000000).toString());
          }
          if (infringementData?.MaxAttachments) {
            setFileNumberLimit(parseInt(infringementData.MaxAttachments, 10));
          }
        }
      });
    };
    getFileInfo();
  }, []);
  return (
    <>
      <div className="vfH2">Reason and supporting documents</div>
      <Field
        className={styles.largeTextBox}
        component={LimitedTextAreaLarge}
        name="DetailsForCircumstances"
        value={values.DetailsForCircumstances}
        limit={3000}
        title="Tell us the reason why you only found out about your fines in the last 14 days. We will use this information to assess your application."
        isMandatory
      />
      <br />
      <p className={styles.titleBold}>
        You should also provide supporting documents or information with your application.
        {' '}
        <span className={styles.optionalTitle}> (optional)</span>
      </p>
      <p>
        At
        {' '}
        <a href="/Your-options/Find-a-form" target="_blank" rel="noreferrer">
          Find a form
        </a>
        {' '}
        you can also download and complete any other relevant applications, such as a nomination statement or court request, and upload these at the same time, along with any supporting evidence.
      </p>
      <p>
        {fileDescrption}
      </p>

      <Field
        component={FileUploadGroup}
        uploadAReport="SupportingDocNameField"
        uploadFieldArrayName="SupportingDocuments"
        whoPrepared="SupportingDocFilesProvider"
        briefDescription="SupportingDocFilesDescription"
        fileSizeErrorField="SupportingDocFieldErrorHandle"
        fileUploadFailErrorField="SupportingDocFileUploadErrorHandle"
        UploadFileSectionError="SupportingDocUploadFileSectionError"
        fileSizelimit={fileSizeLimit}
        totalFileLimit={fileNumberLimit}
        hasPrepared={false}
        hasDescribe={false}
        formType={FormType.INFRINGEMENTEXTENSION}
      />
      <br />
    </>
  );
}

export default InfringementExtStep6;
